import { defineMessages, useIntl } from 'react-intl';

import { LogService } from '../../../../services/log-service';

export const messages = defineMessages({
  silver: {
    description: 'silver plan name',
    defaultMessage: 'Silver',
    id: 'bUhbRb',
  },
  starter: {
    description: 'starter plan name',
    defaultMessage: 'Starter',
    id: '4onNZY',
  },
  bronze: {
    description: 'bronze plan name',
    defaultMessage: 'Bronze',
    id: 'rPL8ty',
  },
  gold: {
    description: 'gold plan name',
    defaultMessage: 'Gold',
    id: 'Qhm91/',
  },
  platinum: {
    description: 'platinum plan name',
    defaultMessage: 'Platinum',
    id: 'Rw2OUE',
  },
  enterprise: {
    description: 'enterprise plan name',
    defaultMessage: 'Enterprise',
    id: 'Tcv3nm',
  },
  highvolume: {
    description: 'high volume plan name',
    defaultMessage: 'High Volume',
    id: '7tTLj6',
  },
  highvolumelegacy: {
    description: 'legacy high volume plan name',
    defaultMessage: 'High Volume (Legacy)',
    id: 'oC+uam',
  },
  accelerate: {
    description: 'accelerate plan name',
    defaultMessage: 'Accelerate',
    id: '0bNQue',
  },
  startup: {
    description: 'startup plan name',
    defaultMessage: 'Startup',
    id: 'OUjvt5',
  },
  essentials: {
    description: 'essentials plan name',
    defaultMessage: 'Essentials',
    id: 'EdCnFi',
  },
  growth: {
    description: 'growth plan name',
    defaultMessage: 'Growth',
    id: 'bK5JoK',
  },
  scale: {
    description: 'scale plan name',
    defaultMessage: 'Scale',
    id: 'HStjY7',
  },
  freestarter: {
    description: 'free starter plan name',
    defaultMessage: 'Free Starter',
    id: '/VyyoB',
  },
  trial: {
    description: 'Trial plan name',
    defaultMessage: 'Trial',
    id: 'sz0H5P',
  },
  stampsplan: {
    description: 'Stamps plan name',
    defaultMessage: 'Stamps Plan',
    id: 'U8qfMP',
  },
  endiciaplan: {
    description: 'Endicia plan name',
    defaultMessage: 'Endicia Plan',
    id: 'BmT31j',
  },
  upsctplight: {
    description: 'UPS CTP Light plan name',
    defaultMessage: 'UPS CTP Light',
    id: 'Tfp7P0',
  },
  upsctpsmall: {
    description: 'UPS CTP Small plan name',
    defaultMessage: 'UPS CTP Small',
    id: '2ESc9o',
  },
  upsctpmedium: {
    description: 'UPS CTP Medium plan name',
    defaultMessage: 'UPS CTP Medium',
    id: 'R+jxP4',
  },
  upsctplarge: {
    description: 'UPS CTP Large plan name',
    defaultMessage: 'UPS CTP Large',
    id: '+h+h1V',
  },
  upsctpextralarge: {
    description: 'UPS CTP Extra Large plan name',
    defaultMessage: 'UPS CTP Extra Large',
    id: 'HsU/na',
  },
  upsdcbasic: {
    description: 'UPS Digital Connections Basic plan name',
    defaultMessage: 'UPS Digital Connections Basic',
    id: 'Tm6fn6',
  },
  upsdcintermediate: {
    description: 'UPS Digital Connections Intermediate plan name',
    defaultMessage: 'UPS Digital Connections Intermediate',
    id: 'njd1cN',
  },
  upsdcadvanced: {
    description: 'UPS Digital Connections Advanced plan name',
    defaultMessage: 'UPS Digital Connections Advanced',
    id: '6emSCZ',
  },
  upsdcenterprise: {
    description: 'UPS Digital Connections Enterprise plan name',
    defaultMessage: 'UPS Digital Connections Enterprise',
    id: 'q/kv9b',
  },
  developer: {
    description: 'Developer plan name',
    defaultMessage: 'Developer',
    id: '1EXyk3',
  },
  staff: {
    description: 'Staff plan name',
    defaultMessage: 'Staff',
    id: 'SErUsO',
  },
  'stamps.com': {
    description: 'Stamps.com plan name',
    defaultMessage: 'Stamps.com',
    id: 'yX2+TD',
  },
  freepostal: {
    description: 'free postal plan name',
    defaultMessage: 'Free Postal',
    id: 'xyIhKK',
  },
  free: {
    defaultMessage: 'Free',
    description: 'Name for the "Free" plan',
    id: '2kccPI',
  },
  standard: {
    defaultMessage: 'Standard',
    description: 'Name for the "Standard" plan',
    id: 'WdAv96',
  },
  premium: {
    defaultMessage: 'Premium',
    description: 'Name for the "Premium" plan',
    id: 'OAtH9A',
  },
});

export const localizedPlanNameMessageDescriptor = (name) => {
  const nameWithoutSpace = name?.replace(/\s*\(*\)*/g, '').toLowerCase() ?? '';
  if (!messages[nameWithoutSpace]) {
    LogService.logInfo(`no formatted message for plan name: ${name}`);
  }
  const messageDescriptor = messages[nameWithoutSpace] ?? { id: 'plan-name-helper.name', defaultMessage: name };
  return {
    messageDescriptor,
    values: {},
  };
};

/**
 * @param {string} planName - Plan name in default language
 * @returns {string} - Plan name in user's selected language
 */
export const useLocalizedPlanName = (planName) => {
  const intl = useIntl();

  if (!planName) {
    return '';
  }

  const { messageDescriptor, values } = localizedPlanNameMessageDescriptor(planName);

  return intl.formatMessage(messageDescriptor, values);
};
